import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchUserAddresses =
  (id, pagination = true) =>
  dispatch =>
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get(`/clients/${id}/addresses`, { pagination }).then(response => {
      dispatch({
        type: types.FETCH_USERADDRESSES,
        payload: {
          addresses: response['hydra:member'],
          pagination: false,
        },
      });
      return response['hydra:member'];
    });

export const removeAddress = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/addresses/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_ADDRESS,
      payload: {
        address: id,
      },
    });
  });
